// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"InfoPages_infoCardContainer__AebM+"};